import React, { useEffect } from "react";
import type { ComponentType } from "react";
import { connect, useSelector } from "react-redux";
import type { State } from "../store";
import {
  loadHabit,
  deleteHabit,
  installHabit,
  removeHabit,
} from "./actionCreators";
import { getHabit, getHabitIsInstalled } from "./selectors";
import { getIsAuthenticated } from "../user/selectors";
import type { Habit } from "./types";
import { useParams } from "react-router-dom";

export type OwnProps = {};
export type StateProps = {
  isOwner: boolean;
  isIntroEnabled: boolean;
  isInstalled: boolean;
  showManageOptions: boolean;
};
export type DispatchProps = {
  deleteHabit: (arg0: Habit) => void;
  installHabit: (arg0: string) => void;
  removeHabit: (arg0: string) => void;
};
export type ComponentProps = StateProps &
  DispatchProps &
  OwnProps & {
    habit: Habit;
  };
export type LoadingComponentProps = StateProps &
  DispatchProps &
  OwnProps & {
    loadHabit: (arg0: string, arg1: number) => void;
  };
export default function HabitContainer(
  ComposedComponent: ComponentType<ComponentProps>
): ComponentType<OwnProps> {
  const mapStateToProps = (state, ownProps) => {
    const isIntroEnabled = !getIsAuthenticated(state);
    const showManageOptions = getIsAuthenticated(state);
    return {
      ...ownProps,
      isIntroEnabled,
      showManageOptions,
    };
  };

  const mapDispatchToProps = {
    loadHabit,
    deleteHabit,
    installHabit,
    removeHabit,
  };

  const LoadingComponent = function (props: LoadingComponentProps) {
    const { userId1, userId2, createdms: createdmsstr } = useParams();
    const userId = userId1 + ":" + userId2;
    const createdms = parseInt(createdmsstr);
    const habit = useSelector<State, Habit | null | undefined>((state) =>
      getHabit(state, userId, createdms)
    );
    const { showManageOptions, loadHabit, ...otherProps } = props;
    const isInstalled = useSelector<State, boolean>((state) =>
      showManageOptions
        ? getHabitIsInstalled(state, habit != null ? habit.habitId : null)
        : false
    );

    useEffect(() => {
      if (habit == null) {
        loadHabit(userId, createdms);
      }
    }, [userId, createdms, loadHabit, habit]);
    if (habit == null) {
      return null;
    } else {
      const isOwner = habit.userId === userId;
      // composed components should always have habit + habitId,
      // but not loadHabit
      return (
        <ComposedComponent
          {...otherProps}
          showManageOptions={showManageOptions}
          habit={habit}
          isOwner={isOwner}
          isInstalled={isInstalled}
        />
      );
    }
  };

  return connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
  )(LoadingComponent);
}
